import { render, staticRenderFns } from "./MenuLayout.vue?vue&type=template&id=6ef2d0ca&scoped=true"
import script from "./MenuLayout.vue?vue&type=script&lang=js"
export * from "./MenuLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef2d0ca",
  null
  
)

export default component.exports